/**
 * Shopify Variant Selector Component
 * Handles variant selection, URL updates, and form synchronization
 */

class VariantSelectsNew extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.updateOptions();
    this.updateMasterId();
    this.addonOnChange();
  }

  formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    const value = Number(cents || 0);

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
      if (isNaN(number) || number === null) return "0";

      const fixed = (number / 100).toFixed(precision);
      const parts = fixed.split(".");
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
    }

    const formatString = format || (window.money_format || "{{ shop.money_format }}");
    const match = formatString.match(placeholderRegex);
    const placeholder = match ? match[1] : "amount";

    let formatted = "";
    switch (placeholder) {
      case "amount":
        formatted = formatWithDelimiters(value, 2, ",", ".");
        break;
      case "amount_no_decimals":
        formatted = formatWithDelimiters(value, 0, ",", ".");
        break;
      case "amount_with_comma_separator":
        formatted = formatWithDelimiters(value, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        formatted = formatWithDelimiters(value, 0, ".", ",");
        break;
      default:
        formatted = formatWithDelimiters(value, 2, ",", ".");
    }

    return formatString.replace(placeholderRegex, formatted);
  }

  addonOnChange(){
    let _self = this;
    let selectedAddons = document.querySelectorAll(`.jci-addons input`);
    selectedAddons.forEach(el => {
      el.addEventListener('change', function(){
        _self.totalWithAddons();
      })
    });
  }

  totalWithAddons(){
    let _self = this;
    let jciAddonEl = document.querySelector(`.jci-addons`);
    let jciAddonMainPrice = jciAddonEl.querySelector(`.main-product-price`).textContent;
    let totalAmount = (parseFloat(jciAddonMainPrice ?? 0));
    let moneyFormat = jciAddonEl.querySelector(`.main-product-price-format`).textContent;
    let selectedAddons = jciAddonEl.querySelectorAll(`input:checked`);
    selectedAddons.forEach(el => {
      totalAmount += (parseFloat(el.dataset.amount ?? 0));
    });
    document.querySelectorAll(`.price__regular .price-item.price-item--regular`).forEach(el => {
      el.textContent = _self.formatMoney(totalAmount, moneyFormat);;
    })
  }

  async onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      await this.renderProductInfo();
      this.updateShareUrl();
    }
    await this.totalWithAddons();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input, select')).find(
        (input) => {
          return input.checked || input.selected || input.value
        }
      )?.value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (!mediaGallery) return;

    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;

    const parent = newMedia.parentElement;
    if (parent.firstChild !== newMedia) {
      parent.prepend(newMedia);
    }

    // Trigger media gallery update
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    );

    // Update modal media if it exists
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (modalContent) {
      const newModalMedia = modalContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`
      );
      if (newModalMedia) {
        modalContent.prepend(newModalMedia);
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );

    
    productForms.forEach((productForm) => {
      const inputs = productForm.querySelectorAll('input[name="id"],input[name="id[]"]');
      if (inputs) {
        inputs.forEach((input) => {
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.section;
    console.log('requestedVariantId', requestedVariantId)

    return fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // Only update if we're still on the same variant
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
        }

        
        const formDestination = document.getElementById(`product-form-com-${this.dataset.section}`);
        const formSource = html.getElementById(
          `product-form-com-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );
        if (formSource && formDestination) {
          formDestination.innerHTML = formSource.innerHTML;
        }
        
        const jciAddonsDest = document.querySelector(`.jci-addon-${this.dataset.section}`);
        const jciAddonsSource = html.querySelector(
          `.jci-addon-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );
        if (jciAddonsSource && jciAddonsDest) {
          jciAddonsDest.innerHTML = jciAddonsSource.innerHTML;
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');

        // Update SKU
        const sku = document.getElementById(`Sku-${this.dataset.section}`);
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );
        if (sku && skuSource) {
          sku.innerHTML = skuSource.innerHTML;
        }

        // Update inventory status
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );

        if (inventorySource && inventoryDestination) {
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        }

        // Update volume pricing
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
        const volumeNoteSource = html.getElementById(
          `Volume-Note-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );
        if (volumeNote && volumeNoteSource) {
          volumeNote.innerHTML = volumeNoteSource.innerHTML;
        }

        // Update price per item
        const pricePerItemDest = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );

        if (pricePerItemSource && pricePerItemDest) {
          pricePerItemDest.innerHTML = pricePerItemSource.innerHTML;
        }

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      })
      .catch((e) => {
        console.error('Error fetching product info:', e);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button?.querySelector('[name="add"]');
    const addButtonText = button?.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    
    if (!addButton) return;
    
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    if (this.variantData) {
      return this.variantData;
    }
    
    const variantScript = this.querySelector('[type="application/json"]');
    if (!variantScript) {
      console.error('Variant data script not found');
      return [];
    }
    
    try {
      const data = JSON.parse(variantScript.textContent);
      // Handle different possible data structures
      this.variantData = Array.isArray(data) ? data : (data.variants || []);
      return this.variantData;
    } catch (e) {
      console.error('Error parsing variant data:', e);
      return [];
    }
  }
}

customElements.define('variant-selects', VariantSelectsNew);